import React from "react";
// import HomeBanner from "../../sections/HomeSection/Home-Banner/banner";
import HomeAboutSection from "../../sections/HomeSection/Home-About/home-about-section";
// import WelcomeSection from "../../sections/HomeSection/Home-product-section/Home-products";
// import PaperBagGallery from "../../sections/HomeSection/Home-products-2/home-products-2";
import HomeProducts from "../../sections/HomeSection/Home-product-section/Home-products";
// import ProductsSection from "../../sections/AboutSection/about-products2/about-products2";
// import StatsCounter from "../../sections/HomeSection/our-bussiness-journey/our-bussiness-journey";
// import ServiceSection from "../../sections/AboutSection/about-products2/about-products2";
import ClientCarousel from "../../sections/HomeSection/Home-client-corousel/Home-client-corousel";
import VerticalSlider from "../../sections/HomeSection/Banner2/banner2";
const HomePage = ()=>{

        return(
            <div className="container-fluid p-0">
            <div className="row">
                <div className="col-12">
                    <VerticalSlider/>
                    {/* <HomeBanner /> */}
                    {/* <StatsCounter/> */}
                    <HomeAboutSection />
                    {/* <WelcomeSection /> */}
                    {/* <ServiceSection/> */}

                    {/* <ProductsSection/> */}
                    <HomeProducts/>
                    {/* <PaperBagGallery/> */}
                    <ClientCarousel/>
                </div>
            </div>
        </div>
    

    )
}

export default  HomePage


